<template>
  <div class="main-box">
    <el-card class="box-card" shadow="never">
      <el-row style="padding-bottom: 10px">
        <el-col :span="24" style="text-align: left;line-height: 40px">
          <el-input ref="assetSn" v-model="formData.assetSn" placeholder="请输入或扫资产码" @keyup.enter.native="search" style="width: 300px"></el-input>
          <el-button type="primary" style="margin-left: 10px" :loading="loading" @click="search">查询</el-button>
          <MessageComponent ref="searchMessage"/>
        </el-col>
      </el-row>
      <MaterialInfo :busItem="busItem" :lendOrder="lendOrder" :lend-order-item="lendOrderItem" station="advanced"/>
      <el-form :model="formData" label-width="130px">
        <el-row v-if="'goldenKey' === this.busItem.sortTestType">
          <el-col>
            <el-form-item label="资产码：">
              <vue-qr :size="80" :margin="0" :text="formData.assetSn"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="检验类型：">
              <el-select v-model="busItem.sortTestType" disabled class="form-item">
                <el-option label="外观" value="appearance"></el-option>
                <el-option label="电性能" value="electric"></el-option>
                <el-option label="金钥匙" value="goldenKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="检验提示：">
              <div class="fun-tip">{{ ruleText }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="外观检验结果：">
              <el-radio-group v-model="formData.test1Result" @change="calcResult">
                <el-radio :label="true">正常</el-radio>
                <el-radio :label="false">不良</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="外观是否可修复：" v-if="formData.test1Result===false">
              <el-radio-group v-model="formData.test1Repairable">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否可翻新：" v-if="formData.test1Repairable===true&&busItem.planCategory=='011'">
              <el-radio-group v-model="formData.test1Refurbishable">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="维修商代码：">
              <el-select v-model="formData.test1RepairerCode" filterable class="form-item">
                <el-option
                    v-for="item in repairerCodeList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="外采标签：">
              <el-input v-model.trim="formData.outsourcedLabel" placeholder="外采商到货标签" maxlength="20" class="form-item"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="外观不良代码：" v-if="formData.test1Result===false">
              <el-select v-model="formData.test1TroubleCode" filterable placeholder="请选择外观不良代码" class="form-item">
                <el-option
                    v-for="item in troubleList"
                    :key="item.code"
                    :label="item.code+' '+item.name"
                    :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="外观不良原因：" v-if="formData.test1Result===false">
              <el-input v-model="formData.test1TroubleReason" type="textarea" :rows="2" class="form-item"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="needTest2">
          <el-col :span="8">
            <el-form-item label="电性能检验结果：">
              <el-radio-group v-model="formData.test2Result" @change="calcResult">
                <el-radio :label="true">正常</el-radio>
                <el-radio :label="false">不良</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电性能不良代码：" v-if="formData.test2Result===false">
              <el-select v-model="formData.test2TroubleCode" filterable placeholder="请选择电性能不良代码" class="form-item">
                <el-option
                    v-for="item in troubleList"
                    :key="item.code"
                    :label="item.code+' '+item.name"
                    :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电性能不良原因：" v-if="formData.test2Result===false">
              <el-input v-model="formData.test2TroubleReason" type="textarea" :rows="2" class="form-item"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="贴纸技服码：" v-if="needStickerCode">
              <el-input v-model.trim="formData.busItemInfo.stickerCode" placeholder="贴纸技服码" maxlength="20" class="form-item"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="检验结果：">
              <el-select v-model="formData.testResult" class="form-item">
                <el-option
                    v-for="item in testResultList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="处置意见：">
              <el-select v-model="formData.disposeOpinion" class="form-item">
                <el-option
                    v-for="item in disposeOpinionList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="检验结果描述：">
              <el-input v-model="formData.testResultRemark" type="textarea" :rows="2" class="form-item"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="外观检验照片：">
              <PhotographComponent @setImgIds="setTest1ImgIds" ref="test1ImageUpload"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电性能检验照片：" v-if="needTest2">
              <PhotographComponent @setImgIds="setTest2ImgIds" ref="test2ImageUpload"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="TPM检验照片：" v-if="isTPM">
              <PhotographComponent @setImgIds="setTpmImgIds" ref="tpmImageUpload"/>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="check-tip-title" v-if="categoryGroupList.length>0">【{{ busItem.planCategoryName }}】检验项目：</div>
        <el-row v-for="item in categoryGroupList" :key="item.categoryType" class="border-top">
          <el-col :span="3">
            <el-form-item label="" style="color: #606266;font-weight: bold" label-width="0px">{{ item.categoryType }}</el-form-item>
          </el-col>
          <el-col :span="21">
            <el-row>
              <el-col :span="12" v-for="subItem in item.items" :key="subItem.name">
                <el-row>
                  <el-form-item style="text-align: left" :label="subItem.categoryName+'：'" label-width="185px">
                    <el-radio-group v-model="subItem.categoryResult">
                      <el-radio :label="true">OK</el-radio>
                      <el-radio :label="false">NG</el-radio>
                    </el-radio-group>
                    <span class="tip" style="padding-left: 10px">{{ subItem.categoryTip }}</span>
                  </el-form-item>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="联想目标库区：" v-if="lenovoStore&&showLenovoSelect">
              <el-select v-model="formData.storeType" filterable placeholder="请选择联想目标库区" class="form-item">
                <el-option
                    v-for="item in lenovoStoreList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8"></el-col>
          <el-col :span="8"></el-col>
        </el-row>
        <el-row>
          <el-col :span="5" style="text-align: right">
            <el-button type="primary" @click="submit">高级检验结果提交</el-button>
          </el-col>
          <el-col :span="19">
            <MessageComponent ref="commitMessage"/>
          </el-col>
        </el-row>
      </el-form>

    </el-card>
  </div>
</template>

<script>
import MessageComponent from "@/components/MessageComponent";
import MaterialInfo from "@/views/material/MaterialInfo";
import PhotographComponent from "@/components/PhotographComponent";
import VueQr from 'vue-qr';

export default {
  name: "AdvancedTest",
  components: {PhotographComponent, MaterialInfo, MessageComponent, VueQr},
  data() {
    return {
      formData: {
        assetSn: '',
        test1Result: undefined,
        test1Repairable: '',
        test1Refurbishable: '',
        test1RepairerCode: '',
        test1TroubleReason: '',
        test1TroubleCode: '',
        test1ImageIds: [],
        test2ImageIds: [],
        tpmImageIds: [],
        test2Result: undefined,
        test2TroubleCode: '',
        test2TroubleReason: '',
        testResult: '',
        disposeOpinion: '',
        testResultRemark: '',
        currentPosition: '',
        storeType: '',
        judgeStoreType: '',
        busItemInfo: {
          testRemark: '',
          stickerCode: ''
        },
        categoryRecords: []
      },
      canCheck: false,
      mustPhotograph: false,
      needStickerCode: false,
      busItem: {},
      lendOrder: {},
      lendOrderItem: {},
      troubleList: [],
      ruleText: '',
      loading: false,
      submitLoading: false,
      lenovoStoreList: [],
      showLenovoSelect: false,
      categoryGroupList: []
    }
  },
  computed: {
    disposeOpinionList() {
      return this.$store.getters.getDictList('disposeOpinion') || [];
    },
    testResultList() {
      return this.$store.getters.getDictList('testResult') || [];
    },
    storeTypeList() {
      return this.$store.getters.getDictList('storeType') || [];
    },
    repairerCodeList() {
      return this.$store.getters.getDictList('repairerCode') || [];
    },
    lastTest() {
      return true
    },
    lenovoStore() {
      return this.lastTest && this.busItem.lenovoJudgeStore
    },
    judgeStoreType() {
      if (this.lenovoStore && this.showLenovoSelect) {
        return 'lenovo_more'
      } else if (this.lenovoStore) {
        return 'lenovo_one'
      }
      return 'system_auto'
    },
    needTest2() {
      let sortTestType = this.busItem.sortTestType;
      let typeArr = ['electric', 'goldenKey'];
      if (sortTestType === 'appearance' && typeArr.includes(this.busItem.busItemInfo?.testType)) {
        return true
      }
      return typeArr.includes(sortTestType);
    },
    needEmail() {
      if (this.formData.testResult == '1') {
        return false;
      }
      //采购订单、buffer订单有不良时提示
      if (this.busItem.materialSource == '10' || this.busItem.materialSource == '90' || this.busItem.materialSource == '100') {
        return true;
      }
      //索赔归还指定供应商时提示
      if (this.busItem.materialSource == '20' && this.busItem.supplierCode) {
        let str = ',2009103,2016063,2015508,2015819,2017277,2015818,4027687,2000018,2007766,2012756,2002534,2013506,2013819,2020191,'
        return str.indexOf(',' + this.busItem.supplierCode + ',') != -1;
      }
      //索赔归还指定供应商时提示,计划大类为LCD模组
      if (this.busItem.materialSource == '20' && this.busItem.supplierCode && this.busItem.planCategory == '077') {
        let str = ',1000338,'
        return str.indexOf(',' + this.busItem.supplierCode + ',') != -1;
      }
      //索赔归还指定供应商时提示,计划大类为主板
      if (this.busItem.materialSource == '20' && this.busItem.supplierCode
          && (this.busItem.planCategory == '041' || this.busItem.planCategory == '051' || this.busItem.planCategory == '078' || this.busItem.planCategory == '079')) {
        let str = ',4002529,VS00000027,2010247,2000018,'
        return str.indexOf(',' + this.busItem.supplierCode + ',') != -1;
      }
      return false;
    },
    isTPM() {
      //主板、电性能(非金钥匙)安全芯片TPM检查  含DT 或dT或YT或yT这4种情况
      if (this.busItem.sortTestType !== 'electric') {
        return false
      }

      let planCategoryArr = ['041', '051', '078', '079'];
      if (!planCategoryArr.includes(this.busItem.planCategory)) {
        return false
      }
      let name = this.busItem.materialName || ''
      if (name.indexOf('DT') != -1 || name.indexOf('dT') != -1 || name.indexOf('YT') != -1 || name.indexOf('yT') != -1) {
        return true;
      }
      return false;
    }
  },
  methods: {
    calcResult() {
      if (this.busItem.sortTestType == 'appearance') {
        if (this.formData.test1Result) {
          this.formData.testResult = '1'
          this.formData.disposeOpinion = '20'
        } else {
          this.formData.testResult = undefined
          this.formData.disposeOpinion = undefined
        }
      } else {
        if (this.formData.test1Result && this.formData.test2Result) {
          this.formData.testResult = '1'
          this.formData.disposeOpinion = '20'
        } else {
          this.formData.testResult = undefined
          this.formData.disposeOpinion = undefined
        }
      }

    },
    resetValues() {
      this.formData.test1Result = undefined
      this.formData.test1Repairable = ''
      this.formData.test1Refurbishable = ''
      this.formData.test1RepairerCode = ''
      this.formData.test1TroubleReason = ''
      this.formData.test1TroubleCode = ''
      this.formData.test2Result = undefined
      this.formData.test2TroubleCode = ''
      this.formData.test2TroubleReason = ''
      this.formData.test1ImageIds = []
      this.formData.test2ImageIds = []
      this.formData.tpmImageIds = []
      this.formData.testResult = ''
      this.formData.testResultRemark = ''
      this.formData.disposeOpinion = ''
      this.formData.storeType = '';
      this.formData.busItemInfo.testRemark = '';
      this.formData.busItemInfo.stickerCode = '';
      this.lenovoStoreList = [];
      this.showLenovoSelect = false;
      this.categoryGroupList = []
      this.formData.categoryRecords = []

      this.canCheck = false;
      this.mustPhotograph = false;
      this.needStickerCode = false;
      this.busItem = {};
      this.lendOrder = {};
      this.lendOrderItem = {};
      this.troubleList = [];
      this.ruleText = '';
      this.loading = false;
      this.submitLoading = false;
      this.$refs.test1ImageUpload.onClear();
      if (this.$refs.test2ImageUpload) {
        this.$refs.test2ImageUpload.onClear();
      }
      if (this.$refs.tpmImageUpload) {
        this.$refs.tpmImageUpload.onClear();
      }
    },
    async submit() {
      this.$refs.commitMessage.clear();
      if (!this.lastTest) {
        this.formData.storeType = '';
        this.lenovoStoreList = [];
        this.showLenovoSelect = false;
      }
      let currentPosition = localStorage.getItem('current_position') || '';
      if (!currentPosition) {
        return this.$refs.commitMessage.showError('未设置工位，请重新登录系统并设置工位信息');
      } else {
        this.formData.currentPosition = currentPosition;
      }
      if (!this.formData.assetSn) {
        return this.$refs.commitMessage.showError('请输入或扫资产码');
      }
      if (!this.canCheck) {
        return this.$refs.commitMessage.showError('该资产码不符合高级检验条件');
      }

      if (this.formData.test1Result !== true && this.formData.test1Result !== false) {
        return this.$refs.commitMessage.showError('请选择外观检验结果');
      }
      //不良时校验不良字段
      if (!this.formData.test1Result) {
        if (this.formData.test1Repairable === '') {
          return this.$refs.commitMessage.showError('请选择外观是否可修复');
        }
        if (this.formData.test1Repairable === true && this.busItem.planCategory == '011' && this.formData.test1Refurbishable === '') {
          return this.$refs.commitMessage.showError('请选择是否可翻新');
        }
        if (this.formData.test1TroubleCode === '') {
          return this.$refs.commitMessage.showError('请选择外观不良代码');
        }
      }

      if (this.needTest2 && this.formData.test2Result !== false && this.formData.test2Result !== true) {
        return this.$refs.commitMessage.showError('请选择电性能检验结果');
      }

      if (this.formData.test2Result === false) {
        if (!this.formData.test2TroubleCode) {
          return this.$refs.commitMessage.showError('请选择电性能不良代码');
        }
      }

      let good = this.formData.test1Result;
      if (this.needTest2) {
        good = this.formData.test1Result && this.formData.test2Result;
      }
      if (!this.formData.testResult) {
        return this.$refs.commitMessage.showError('请选择检验结果');
      } else if (good && this.formData.testResult != '1') {
        return this.$refs.commitMessage.showError('检验结果必须为合格');
      }
      if (!this.formData.disposeOpinion) {
        return this.$refs.commitMessage.showError('请选择处置意见');
      } else if (good && this.formData.disposeOpinion != '20') {
        return this.$refs.commitMessage.showError('处置意见必须为合格');
      }

      if (this.isTPM && this.formData.tpmImageIds.length == 0) {
        return this.$refs.commitMessage.showError('TPM检验照片不能为空');
      }

      this.formData.categoryRecords = []
      if (this.categoryGroupList && this.categoryGroupList.length > 0) {
        let allOK = true;
        for (let categoryGroup of this.categoryGroupList) {
          for (let categoryObj of categoryGroup.items) {
            if (categoryObj.categoryResult !== true && categoryObj.categoryResult !== false) {
              return this.$refs.commitMessage.showError('请按检验项目【' + categoryGroup.categoryType + '：  ' + categoryObj.categoryName + '】进行检验');
            }
            if (categoryObj.categoryResult === false) {
              allOK = false
            }
            this.formData.categoryRecords.push({
              categoryId: categoryObj.id,
              categoryResult: categoryObj.categoryResult
            })
          }
        }
        if (!allOK && this.formData.test1Result) {
          return this.$refs.commitMessage.showError('检验项目存在NG时，外观检验结果必须为不良');
        } else if (allOK && !this.formData.test1Result) {
          return this.$refs.commitMessage.showError('检验项目全部OK时，外观检验结果必须为合格');
        }
      }

      if (this.mustPhotograph && this.formData.test1ImageIds.length < 1) {
        return this.$refs.commitMessage.showError('请拍外观检验照片');
      }

      //除维修退回、索赔退回、调拨订单，电性能必须照片
      if (this.needTest2 && !['50', '60', '120'].includes(this.busItem.materialSource)) {
        if (this.formData.test2ImageIds.length < 1) {
          return this.$refs.commitMessage.showError('请拍电性能检验照片');
        }
      }


      if (!this.formData.storeType && this.lenovoStore) {
        if (this.lenovoStoreList.length == 0) {
          this.submitLoading = true;
          const {data: storeRes} = await this.$axios.post('/busItem/judgeStore', this.formData);
          this.submitLoading = false;
          if (storeRes.code !== 0) {
            return this.$refs.commitMessage.showError(storeRes.message);
          }
          this.lenovoStoreList = storeRes.data || [];
          if (this.lenovoStoreList.length == 0) {
            this.$message.error('联想判保接口没有返回库区，请将条码及检验结果信息给主管，找联想协助检查判库规则')
          }
        }
        if (this.lenovoStoreList.length == 1) {
          this.formData.storeType = this.lenovoStoreList[0].id;
        } else {
          this.showLenovoSelect = true
          return this.$refs.commitMessage.showError("请选择联想目标仓库");
        }
      }

      if (this.needEmail) {
        this.$confirm('检验不良需要邮件提报', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '我已知晓',
          type: 'warning'
        }).then(() => {
          this.saveAdvancedTestResult()
        })
      } else {
        this.saveAdvancedTestResult();
      }
    },
    async saveAdvancedTestResult() {
      this.submitLoading = true;
      this.formData.judgeStoreType = this.judgeStoreType
      const {data: res} = await this.$axios.post('/busItem/saveAdvancedTestResult', this.formData);
      this.submitLoading = false;
      if (res.code !== 0) {
        return this.$refs.commitMessage.showError(res.message);
      }
      this.$refs.commitMessage.showSuccess('提交成功，下一工站为：' + res.data.nextStationName);
      this.resetValues();
      this.formData.assetSn = '';
      this.$refs.assetSn.focus();
    },
    async search() {
      this.resetValues()
      this.$refs.searchMessage.clear();
      this.$refs.commitMessage.clear();
      if (!this.formData.assetSn) {
        this.$refs.searchMessage.showError('请输入或扫资产码');
        return;
      }
      this.formData.assetSn = this.formData.assetSn.trim();

      this.loading = true;
      const {data: res} = await this.$axios.get('/busItem/queryInfoForAdvanced', {
        params: {assetSn: this.formData.assetSn}
      });
      this.loading = false;

      if (res.code !== 0) {
        this.$refs.searchMessage.showError(res.message);
        return
      }

      if (!res.data.busItem) {
        return this.$refs.searchMessage.showError('资产码不正确');
      }

      this.busItem = res.data.busItem || {};
      this.busItem.busItemInfo = this.busItem.busItemInfo || {};
      this.lendOrder = res.data.lendOrder || {};
      this.lendOrderItem = res.data.lendOrderItem || {};
      this.troubleList = res.data.troubleList || [];
      this.mustPhotograph = res.data.mustPhotograph || false;
      this.needStickerCode = res.data.needStickerCode || false;

      this.ruleText = res.data.ruleText || '';
      let inLineCnt = this.busItem.busItemInfo.inLineCnt || 0;
      if (inLineCnt > 2) {
        this.ruleText = '【第' + inLineCnt + '次来货】' + this.ruleText
      }

      let categoryList = res.data.categoryList || []
      this.categoryGroupList = []
      for (let item of categoryList) {
        item.categoryResult = true
        /*//检验项目：主板外设置默认
        if (!['041', '051', '078', '079'].includes(this.busItem.planCategory)) {
          item.categoryResult = true
        }*/
        let categoryObj = this.categoryGroupList.find(obj => {
          return obj.categoryType === item.categoryType
        });
        if (categoryObj) {
          categoryObj.items.push(item);
        } else {
          this.categoryGroupList.push({
            categoryType: item.categoryType,
            items: [item]
          })
        }
      }

      if (res.data.canCheck === false) {
        return this.$refs.searchMessage.showError('该物品需要高级检验人员检验');
      }

      if (this.busItem.currentStation != 'advanced') {
        let msg = '该物品当前工站不是高级检验工站';
        if (this.busItem.currentStationStatus == 'finish' && this.busItem.nextStationName) {
          msg += '，工站为：' + this.busItem.nextStationName;
        } else if (this.busItem.currentStationName) {
          msg += '，工站为：' + this.busItem.currentStationName;
        }
        return this.$refs.searchMessage.showError(msg);
      } else if (this.busItem.currentStationStatus == 'finish') {
        return this.$refs.searchMessage.showError('当前工站已完成，下一工站为：' + this.busItem.nextStationName);
      }

      this.canCheck = true;
    },
    setTest1ImgIds(idList) {
      this.formData.test1ImageIds = idList || []
    },
    setTest2ImgIds(idList) {
      this.formData.test2ImageIds = idList || []
    },
    setTpmImgIds(idList) {
      this.formData.tpmImageIds = idList || []
    },
  }
}
</script>

<style scoped>
.fun-tip {
  font-weight: bold;
  font-size: 16px;
  color: red;
}

.form-item {
  width: 320px;
}

.check-tip-title {
  padding-bottom: 5px;
  padding-top: 10px;
  color: #0000FF;
  font-weight: bold;
}

.border-top {
  border-top: 1px solid #ddd;
}
</style>